
/**
 * Module dependencies.
 */

import { NavThemeProps, navTransition, setNavColor } from './nav-theme';
import { color, units } from 'src/styles/utils';
import { navElementAttrs } from './nav-element';
import { switchProp } from 'styled-tools';
import styled, { css } from 'styled-components';

/**
 * Export `NavTertiaryLink` styled component.
 *
 * `Nav / Button Terciary` in the design system: the back-office managed links
 * of the pre navbar. Over the hero the hover keeps the text white, since the
 * design's brown does not hold enough contrast against an image.
 */

const NavTertiaryLink = styled.a.attrs(navElementAttrs)<NavThemeProps>`
  -webkit-tap-highlight-color: transparent;
  appearance: none;
  background: none;
  border: 0;
  border-radius: 100px;
  cursor: pointer;
  display: inline-flex;
  font-size: 12px;
  letter-spacing: 0.01em;
  line-height: 1.5;
  outline: none;
  padding: ${units(1)} ${units(1.5)};
  text-decoration: none;
  text-transform: uppercase;
  transition: color ${navTransition};
  white-space: nowrap;

  ${setNavColor}

  &:focus-visible,
  &:hover {
    text-decoration: underline;

    ${switchProp('colorTheme', {
    dark: css`
        color: ${color('brown400')};
      `,
    light: css`
        color: ${color('white')};
      `
  })}
  }
`;

/**
 * Export `NavTertiaryLink` styled component.
 */

export default NavTertiaryLink;
